// removed by extract-text-webpack-plugin
module.exports = {"marketingLayout":"_2ynU6"};


//////////////////
// WEBPACK FOOTER
// ./banquet/layouts/MarketingLayout/index.sass
// module id = 1529
// module chunks = 1